import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandTiktok,
  IconWorld,
} from "@tabler/icons-react";

export interface SocialLink {
  site: string;
  value: string;
}

export const getSiteIcon = (site: string) => {
  switch (site) {
    case "instagram":
      return IconBrandInstagram;
    case "facebook":
      return IconBrandFacebook;
    case "tiktok":
      return IconBrandTiktok;
    default:
      return IconWorld;
  }
};

export const getSiteName = (site: string) => {
  switch (site) {
    case "instagram":
      return "Instagram";
    case "facebook":
      return "Facebook";
    case "tiktok":
      return "TikTok";
    default:
      return "Website";
  }
};

export const generateSocialLink = (link: SocialLink): string => {
  const { site, value } = link;

  // If the value already starts with http, return as is
  if (value.startsWith("http")) {
    return value;
  }

  // Generate the correct link based on the site
  switch (site) {
    case "instagram":
      return `https://instagram.com/${value.replace("@", "")}`;
    case "facebook":
      return `https://facebook.com/${value}`;
    case "tiktok":
      return `https://tiktok.com/@${value.replace("@", "")}`;
    default:
      // For generic sites, if it doesn't start with http, assume it needs https://
      return value.startsWith("http") ? value : `https://${value}`;
  }
};

export const getSiteColor = (site: string) => {
  switch (site) {
    case "instagram":
      return "#E4405F";
    case "facebook":
      return "#1877F2";
    case "tiktok":
      return "#000000";
    default:
      return "#666666";
  }
};
